export type IIconProps = {
    color?: string;
    size?: IIconSize;
}

export enum IIconSize {
    small = 'SMALL',
    medium = 'MEDIUM',
    large = 'LARGE'
}